import { render, staticRenderFns } from "./wtFile.component.vue?vue&type=template&id=499e6692&"
import script from "./wtFile.component.vue?vue&type=script&lang=js&"
export * from "./wtFile.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports